const messages = {
    accountBox: {
        title: "Dashboard",
        description: "Quickly track your promotions and points.",
        button: "OPEN DASHBOARD",
    },
};

export default {
    messages,
};
